import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

// Import Images
import testShape from "../../images/testimonials/shape.png"
import testPic1 from "../../images/testimonials/pic1.jpg"
import testPic2 from "../../images/testimonials/pic2.jpeg"
import testPic3 from "../../images/testimonials/pic3.jpg"
import testPic4 from "../../images/testimonials/pic4.jpg"
import testPic5 from "../../images/testimonials/pic5.jpeg"
import testPic6 from "../../images/testimonials/pic6.jpg"
// import plusOrange from "../../images/shap/plus-orange.png"
// import squareBlue from "../../images/shap/square-blue.png"
// import circleDots from "../../images/shap/circle-dots.png"
// import circleOrange2 from "../../images/shap/circle-orange-2.png"
import image1 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.14.22 PM.jpeg";
import image2 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.14.59 PM.jpeg";
import image4 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.20.16 PM.jpeg";
import image5 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.20.46 PM.jpeg";
import image6 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.21.10 PM.jpeg";
import image7 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.21.58 PM.jpeg";
import image8 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.22.37 PM.jpeg";
import image9 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.23.04 PM.jpeg";
import image10 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.23.25 PM.jpeg";
import image11 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.23.46 PM.jpeg";
import image12 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.24.14 PM.jpeg";
import image14 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.24.50 PM.jpeg";
import image15 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.25.22 PM.jpeg";
import image16 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.25.35 PM.jpeg";
import image17 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.25.51 PM.jpeg";
import image18 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.26.15 PM.jpeg";
import image19 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.26.29 PM.jpeg";
import image20 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.26.44 PM.jpeg";
import image21 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.27.10 PM.jpeg";
import image22 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.30.22 PM.jpeg";
import image23 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.30.59 PM.jpeg";
import image24 from "../../images/testimonials/WhatsApp Image 2024-11-08 at 9.32.41 PM.jpeg";
import image25 from "../../images/testimonials/PHOTO-2025-01-06-21-05-47.JPG";

class testimonialSection extends Component{
	
	render(){
			
		const settings = {
			dots: false,
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
		};
		const autoplaySettings = {
			dots: false,
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,       // Enable autoplay for this slider only
			autoplaySpeed: 3000,  // 3 seconds between slides
		};
				
		return(
			<>
					
				
				<section className="section-area section-sp3 testimonial-wraper">
					<div className="container">
						<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Testimonial</h6>
							<h2 className="title m-b0">See What Our Patients <br/>Say About Us</h2>
						</div>
						<div className="row align-items-center">
							<div className="col-lg-6 text-center">
								<div className="thumb-wraper">
									<img className="bg-img" src={testShape} alt=""/>
									<ul>
										<li data-member="1"><Link to="#"><img src={testPic1} alt=""/></Link></li>
										<li data-member="2"><Link to="#"><img src={testPic2} alt=""/></Link></li>
										<li data-member="3"><Link to="#"><img src={testPic3} alt=""/></Link></li>
										<li data-member="4"><Link to="#"><img src={testPic4} alt=""/></Link></li>
										<li data-member="5"><Link to="#"><img src={testPic5} alt=""/></Link></li>
										<li data-member="6"><Link to="#"><img src={testPic6} alt=""/></Link></li>
									</ul>
								</div>
							</div>
							<div className="col-lg-6">
								<Slider {...settings} className="testimonial-slide">
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>They are amazing! Today was my first visit and I’m truly amazed on how much they care for their patients. I made an appt during my lunch time and they took me right in at my appt time (no wait), since this was my first apt they took all X-rays and pictures which took no more than 20-30 minutes. Then they proceeded to do my check up and told me all the steps I needed to take to get to a very healthy dental status. My appt lasted about an hour and a half. From the beginning they explained to me what was covered with my insurance and what I would be paying for my procedures going forward. I am so happy i chose them and can’t wait to start my journey with them.</p>
											</div>
											<div className="client-info">
												<h5 className="name">Brenda Zambrano</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
																		<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>I've been going to Family EcoDental for years now and the service and quality of care is consistently top notch. Dr. Figueredo is one of the best dentists I've had and she truly cares about her patients. Her staff is accommodating and friendly and the office is inviting. I moved further away and still go there for dental services. She's nothing short of awesome!</p>
											</div>
											<div className="client-info">
												<h5 className="name">A MO</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>Amazing dentist practice ! The best dental experience I’ve ever had. Dr. Figueredo, Elvia, the dental hygienist that personally works with me, Monica at the reception desk, and the rest of the staff are genuinely respectful and always willingly to work with me and accommodate my appointments in accordance to my hectic schedule. They are very through and have walked me through every step of their recommendations. They are also excellent at reminding me of my upcoming appointments ! 10 out 10 ! Excellent dental practice ! 💫💫💫</p>
											</div>
											<div className="client-info">
												<h5 className="name">Josemely Fernandez</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>The best attention without a doubt, from the moment you enter and the girls at the entrance assist you, Monica and Nelly are wonderful, they make you feel like family, the team of dentists and assistants are incredible, from the first day I feel comfortable with their attention, They don't miss the smallest detail, they have solutions for everything, I am delighted with the attention of this dental team and I recommend this office to do your check-ups and orthodontics, they have everything here, you don't have to go somewhere else…. They are the best in the area, they are incredible.</p>
											</div>
											<div className="client-info">
												<h5 className="name">Alejandra Alayon</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>I've been going to this Dentist for years. They've always been very friendly and professional throughout my countless visits. They also make sure to give/explain to you all options so you can make an informed decision when needed. They are also very flexible in terms of scheduling around your free time and are always prompt. If my appointment was at 12:30, they see me at(or close to) that time. I don't have to wait 30+ minutes like other establishments I experienced.

I find it very convenient as well that they send text reminders when your next appointment is near (I always forget these things). Highly recommend!</p>
											</div>
											<div className="client-info">
												<h5 className="name">Mike Onglengco</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>This place is amazing.. they not only work with you & your schedule but they take their time & every effort to make sure the work is right! I appreciate that so much cause let’s be real who loves going to the dentist lol but this place is different! The front desk staff are unmatched! When you walk in there’s always someone, usually Nelli or Camilo, with the best smile & they are so personable!  Monica & Ricky are super patient with me lol I love talking to them they make you feel like family! Now let’s get to the Docs..Dr. Figueredo pure genius!!  Dr. Alexander is the sweetest oh and her assistant Aliet is the funniest they both make me feel so calm they are great!!!! The whole staff/environment are truly amazing❤️</p>
											</div>
											<div className="client-info">
												<h5 className="name">Taina Seeley</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>If I could give 100 stars I would! Today was my very first time at Eco dental. From the moment I called to schedule my first appointment, they were extremely helpful and very patient. My first visit blew all kinds of expectations I had. Aside from the very clean office, they welcomed me as if I have been there before. They explained everything and asked all questions I had. From toothbrush questions to procedures and schedules. Showed me the comprehensive x rays and pictures for me to understand the importance of taking care of not only your teeth, but your whole entire mouth. Everyone was very professional and I was delighted to be treated by everybody. I’m not sure what took so long for me to go to them. I would recommend to all my friends and family!</p>
											</div>
											<div className="client-info">
												<h5 className="name">Dulce Coste</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>We really love Family Eco Dental , is such an amazing office ! Everyone is incredible friendly each time I visit . From the dentist , to the hygienist and the front desk crew they are wonderful , caring people . They will work out with you to figure out what your insurance covers and spend time and energy to make sure your appointment is as pain free as possible . Like many adults ( and many born and raise in Cuba  😂) , I fear going to the dentist... family eco dental has taken that fear and tossed into the shredder ! I cannot say enough good things about this office . Really wonderful people .</p>
											</div>
											<div className="client-info">
												<h5 className="name">Amaya</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>I love going to Family Eco Dental. All the staff is very professional and friendly (like genuinely friendly and caring), no exception. Everything is amazing there, from service to even decoration. Keep up the excellent work!</p>
											</div>
											<div className="client-info">
												<h5 className="name">Sohayb Stiti</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>I travel 1 hour and half from my house to Family Eco Dental with my whole family because they are excellent. After trying three different dentists who gave me a good service I found Family Eco Dental and I am not living them because of their excellent service from the Receptionist to every single employee in the office who show you that they truly care not only about your oral health but about you. Family Eco Dental and her staff go beyond giving a good service, they make my trip to their office a great experience always.</p>
											</div>
											<div className="client-info">
												<h5 className="name">Kathryn Negroni</h5>
												<p>patient</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
								</Slider>
							</div>	 
						</div>	 
						<div className="row justify-content-center mt-5">
							<div className="col-lg-6">
								<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Before and After</h6>
							<h2 className="title m-b0">See The Results</h2>
							</div>
							<Slider {...autoplaySettings} className="testimonial-slide">
									<div className="slider-item">
										<div className="testimonial-bx2">
											<div className="testimonial-content">
												<img src={image1} alt="Brenda Zambrano" className="client-img" />
											</div>
										</div>
									</div>
									
									
<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image2} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>



<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image4} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image5} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image6} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image7} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image8} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image9} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image10} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image11} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image12} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>



<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image14} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image15} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image16} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image17} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image18} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image19} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image20} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image21} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image22} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>

<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image23} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>
<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image24} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>
<div className="slider-item">
    <div className="testimonial-bx2">
        <div className="testimonial-content">
            <img src={image25} alt="Brenda Zambrano" className="client-img" />
        </div>
    </div>
</div>
								</Slider>
							</div>
						</div>
					</div>
					
					{/* <img className="pt-img1 animate1" src={plusOrange} alt=""/>
					<img className="pt-img2 animate2" src={squareBlue} alt=""/>
					<img className="pt-img3 animate3" src={circleDots} alt=""/>
					<img className="pt-img4 animate4" src={circleOrange2} alt=""/> */}
				</section>
				
			</>
		);
	}
}

export default testimonialSection;